import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { TABLE_ACCOUNT_ROLES, FIELD_KEY_SEPARATOR, FIELD_KEY_PROG, FIELD_KEY_ACTION } from '../globals.ts'
import { AccountRolesModelFields } from './account_roles_model.ts'

const ALIAS_ACCOUNT_ROLES = `${TABLE_ACCOUNT_ROLES}${FIELD_KEY_SEPARATOR}` as const

const PROG_DISPLAY_NAME = `${FIELD_KEY_PROG}display_name` as const
const PROG_ACCOUNT_ROLES_ACTION = `${FIELD_KEY_PROG}${TABLE_ACCOUNT_ROLES}${FIELD_KEY_ACTION}` as const

const FIELD_ACCOUNT_ROLES_ID = `${ALIAS_ACCOUNT_ROLES}${AccountRolesModelFields.id}` as const
const FIELD_ACCOUNT_ROLES_ACCOUNT_ID = `${ALIAS_ACCOUNT_ROLES}${AccountRolesModelFields.account_id}` as const
const FIELD_ACCOUNT_ROLES_ACCOUNT_ROLE_CHOICE_ID = `${ALIAS_ACCOUNT_ROLES}${AccountRolesModelFields.account_role_choice_id}` as const

export const AccountRoleEntrySchema = z
  .object({
    [FIELD_ACCOUNT_ROLES_ID]: z.string().nullish(),
    [FIELD_ACCOUNT_ROLES_ACCOUNT_ID]: z.string().nullish(),
    [FIELD_ACCOUNT_ROLES_ACCOUNT_ROLE_CHOICE_ID]: z.string().nullish(),
    [PROG_DISPLAY_NAME]: z.string().nullish(), // TODO: What is this?
    [PROG_ACCOUNT_ROLES_ACTION]: z.string().nullish()
  })
  .strict()

export const AccountRoleEntryFields = makeFieldKeys(AccountRoleEntrySchema)

export type AccountRoleEntry = z.infer<typeof AccountRoleEntrySchema>

function validateAccountRoleEntry(data: unknown): AccountRoleEntry {
  try {
    return validateWithZodSchema(AccountRoleEntrySchema, data, 'account role entry')
  } catch (error) {
    throw new Error(`Account role entry validation failed: ${error}`)
  }
}
